import React from 'react';
import styled from 'styled-components';

function Footer() {
  return (
    <footer>
      <p>© 2025 2Doyoung</p>
    </footer>
  );
}

export default Footer;